import React, { useEffect, useState } from 'react';
import WOW from 'wowjs';
import Footer from '../../components/foter/footer';
import Navbar from '../../components/navbar/navbar';
import TarjetaConcesionario from '../../components/concesionario/tarjetaConcesionario';
import useConcesionarios, { useZonas, useRegiones } from '../../../hooks/Front/concesionarios/useConcesionarios';
import iconAgendar from '../../../img/floating/agendar.svg';
import iconCotizar from '../../../img/floating/cotizar.svg';

import { Breadcrumb, Button, Checkbox, Select } from 'antd';
import { Col, Container, Row } from 'react-bootstrap';

import '../../../css/textsPredefined.css';
import './concesionario.css';
import { Link } from 'react-router-dom';
import Seo from '../../components/seo/seo';
import CentrosMantencion from '../../components/centrosMantencion/centrosMantencion';

const { Option } = Select;

const Concesionarios = () => {

    const [servicios, setServicios] = useState([])
    const [zona, setZona] = useState(undefined);
    const [region, setRegion] = useState(undefined);

    const [concesionarios] = useConcesionarios(servicios, zona, region);
    const [zonas, isLoadingZona] = useZonas();
    const [regiones, isLoadingRegiones] = useRegiones(zona);


    const handleChangeZona = (value) => {
        setZona(value);
        setRegion(undefined);
    }

    const handleChangeRegion = (value) => {
        setRegion(value);
    }

    const handleChangeServicios = (value) => {
        setServicios(value);
    }

    useEffect(() => {
        new WOW.WOW({
            live: false
        }).init();
    }, []);

    let deshabilitarRegion = regiones === undefined ? true : regiones.length < 1 ? true : false;


    return (
        <>
            <Navbar whatsappVisible={true} />
            <CentrosMantencion seccion="CONCESIONARIOS" />
            <Seo title="Concesionarios -" />
            <Container fluid className="mb-general">
                <Row>
                    <Col className="my-1 my-md-3 px-2 mb-3 ">
                        <Breadcrumb separator=">" className="parrafo-hyundai f-responsive-10">
                            <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
                            <Breadcrumb.Item>
                                Concesionarios
                            </Breadcrumb.Item>

                        </Breadcrumb>
                    </Col>
                </Row>
                <Row>
                    <Col className="my-2 my-md-3 mb-md-5" xs={12}>
                        <h1 className="bold-title-hyundai wow fadeInDown ml-1 mb-md-3 f-center-left f-responsive">Seleccione el tipo de Concesionario</h1>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-center mb-md-4" xs={12}>
                        <p className="parrafo-hyundai text-left d-md-none ml-1 f-responsive-10">Filtrar por:</p>
                        <Checkbox.Group value={servicios} onChange={handleChangeServicios}>
                            <Checkbox className="px-md-5 parrafo-hyundai" value="venta"><p className="d-block d-md-inline font-boxes-c f-responsive-10 mb-0">Venta de vehículos</p></Checkbox>
                            <Checkbox className="px-md-5 parrafo-hyundai" value="servicio"><p className="d-block d-md-inline font-boxes-c f-responsive-10 px-5 px-md-0 mb-0">Servicio técnico</p></Checkbox>
                            <Checkbox className="px-md-5 parrafo-hyundai" value="repuestos"><p className="d-block d-md-inline font-boxes-c f-responsive-10 mb-0">Repuestos</p></Checkbox>
                        </Checkbox.Group>
                    </Col>
                </Row>
                <Row className="my-md-4 mb-md-5 pb-3 border-row-zona">
                    <Col xs={6} className="text-right pr-1 pr-md-3 mb-2 mb-md-5">
                        <Select className="w-select-conce text-left concesionario-select pr-1 parrafo-hyundai f-responsive-10" value={zona} onChange={handleChangeZona} loading={isLoadingZona} placeholder="Zona">
                            {zonas && zonas.length > 0 &&
                                zonas.map((zona, index) => <Option key={index} value={zona.Zona} >{zona.Zona}</Option>)
                            }
                        </Select>
                    </Col>
                    <Col xs={6} className="text-left pl-1">
                        <Select className="w-select-conce parrafo-hyundai concesionario-select pl-1 pl-md-3  f-responsive-10" onChange={handleChangeRegion} value={region} disabled={deshabilitarRegion} loading={isLoadingRegiones} placeholder="Región">
                            {regiones && regiones.length > 0 &&
                                regiones.map((region, index) => <Option key={index} value={region.idRegion}>{region.Region}</Option>)
                            }
                        </Select>
                    </Col>
                </Row>
                {concesionarios && concesionarios.length > 0 &&
                    concesionarios.map((zona, i) => <SeccionZonas key={i} zona={zona} />)
                }
            </Container>
            <BottomBar />
            <Footer float={true} />
        </>
    );
};


export const SeccionZonas = ({ zona, servicios }) => {
    if (zona.length < 1) return null;
    return (
        <Row className="my-md-5 my-0">
            <Col xs={12} md={5} lg={4} xl={3} className="my-md-3 mt-3 mb-2">
                <h2 className="bold-title-hyundai ml-4 d-none d-md-block">Zona {zona[0].Zona}</h2>
                <h5 className="bold-title-hyundai d-md-none mb-0 text-center f-responsive-16">Zona {zona[0].Zona}</h5>
            </Col>
            <Col xs={12} md={7} lg={8} xl={9}>
                <Row>
                    {zona && zona.length > 0 &&
                        zona.map((concesionario, i) => <TarjetaConcesionario key={i} concesionario={concesionario} vieneServicios={servicios} />)
                    }
                </Row>
            </Col>
        </Row>
    )
}

const BottomBar = () => {
    return (
        <Container className="bg-hyundai-light fixed-bottom floating-shadow" fluid>
            <Row>
                <Col xs={6} className="px-0 min-h-floating">
                    <Link to="/agenda-tu-servicio">
                        <Button type="text" className="w-100 h-100 bold-title-hyundai">
                            <img src={iconAgendar} alt="Agenda tu servicio" className="img-fluid icon-floating mr-md-2 mr-lg-3" />
                            <h6 className="bold-title-hyundai d-none d-md-inline color-float">Agenda tu servicio</h6>
                            <p className="bold-title-hyundai mb-0 mt-1 font-floating-btn d-md-none color-btn-floating color-float">Agenda tu servicio</p>
                        </Button>
                    </Link>
                </Col>
                <Col xs={6} className="px-0 bg-cotizar-floating min-h-floating">
                    <Link to="/cotizar">
                        <Button type="text" className="w-100 h-100  bold-title-hyundai ">
                            <img src={iconCotizar} alt="Cotizar" className="img-fluid icon-floating mr-md-2 mr-lg-3" />
                            <h6 className="bold-title-hyundai d-none d-md-inline text-white ">Cotizar</h6>
                            <p className="bold-title-hyundai mb-0 mt-1 font-floating-btn  d-md-none text-white">Cotizar</p>
                        </Button>
                    </Link>
                </Col>
            </Row>
        </Container>
    )
};

export default Concesionarios;